import { resolveWeekStartDay } from '@/features/layouts/weekStart.lib';
import { SidebarRowSelect } from '../SidebarRowSelect';
import { useCustomizeControl } from '../useCustomizeControl';

// 0 = Sunday, 1 = Monday (matches experience.weekStartDay).
const WEEK_START_OPTIONS = [
  { id: 'sun', label: 'Sunday' },
  { id: 'mon', label: 'Monday' },
];

export const WeekStartSelect = () => {
  const { register } = useCustomizeControl();

  return (
    <SidebarRowSelect
      minW="140px"
      options={WEEK_START_OPTIONS}
      {...register<'weekStartDay', string>('child', 'weekStartDay', {
        toField: (id) => (id === 'mon' ? 1 : 0),
        // The column is nullable, and a view that has never had a week start
        // chosen shows its layout's default rather than an arbitrary Sunday.
        toControl: (_, saved) =>
          resolveWeekStartDay(saved) === 1 ? 'mon' : 'sun',
      })}
    />
  );
};
